import { MatchData } from './types';

export const DEFAULT_STATS: MatchData['stats'] = {
  possession: [0, 0],
  passCompletion: [0, 0],
  shots: [0, 0],
  shotsOnTarget: [0, 0],
  corners: [0, 0],
  fouls: [0, 0],
  tackles: [0, 0],
  saves: [0, 0],
  yellowCards: [0, 0],
  redCards: [0, 0],
};

export const DESKTOP_SUBS_PANEL_PADDING_CLASSNAME = 'lg:pr-[340px]';
export const NAVBAR_HEIGHT_PX = 52;
export const SUBS_PANEL_TOP_OFFSET_PX = 40;
export const MOBILE_BREAKPOINT_MEDIA_QUERY = '(max-width: 1023px)';

export const LINEUPS_ANNOUNCEMENT_MINUTES_BEFORE_KICKOFF = 75;

export const FORMATION_PLACE_ORDER: Record<string, number[]> = {
  '4-3-3': [1, 2, 5, 6, 3, 7, 4, 8, 10, 9, 11],
  '4-2-3-1': [1, 2, 5, 6, 3, 8, 4, 7, 10, 11, 9],
  '4-1-4-1': [1, 2, 5, 6, 3, 4, 7, 8, 10, 11, 9],
  '4-4-2': [1, 2, 5, 6, 3, 7, 4, 8, 11, 9, 10],
  '4-1-2-1-2': [1, 2, 5, 6, 3, 4, 7, 11, 8, 10, 9],
  '4-4-1-1': [1, 2, 5, 6, 3, 7, 4, 8, 11, 10, 9],
  '4-3-2-1': [1, 2, 5, 6, 3, 8, 4, 7, 10, 11, 9],
  '4-2-4-0': [1, 2, 5, 6, 3, 4, 8, 7, 9, 10, 11],
  '4-5-1': [1, 2, 5, 6, 3, 6, 4, 10, 8, 11, 9],
  '4-3-1-2': [1, 2, 5, 6, 3, 7, 4, 11, 8, 9, 10],
  '4-2-2-2': [1, 2, 5, 6, 3, 4, 8, 7, 11, 10, 9],
  '4-1-3-2': [1, 2, 5, 6, 3, 4, 7, 8, 11, 9, 10],
  '3-5-2': [1, 6, 5, 4, 2, 7, 11, 8, 3, 10, 9],
  '3-4-2-1': [1, 6, 5, 4, 2, 7, 8, 3, 10, 11, 9],
  '3-1-4-2': [1, 5, 4, 6, 8, 2, 7, 11, 3, 9, 11],
  '3-4-1-2': [1, 6, 5, 4, 2, 7, 8, 3, 9, 10, 11],
  '3-5-1-1': [1, 6, 5, 4, 2, 7, 11, 8, 3, 10, 9],
  '3-3-3-1': [1, 6, 5, 4, 2, 8, 3, 10, 7, 11, 9],
  '3-2-4-1': [1, 6, 5, 4, 2, 3, 10, 7, 8, 11, 9],
  '5-4-1': [1, 2, 6, 5, 4, 3, 7, 8, 10, 11, 9],
  '5-3-2': [1, 2, 6, 5, 4, 3, 7, 8, 11, 10, 9],
  '3-4-3': [1, 6, 5, 4, 2, 7, 8, 3, 10, 9, 11],
  '3-4-3d': [1, 6, 5, 4, 8, 2, 4, 7, 10, 9, 11],
};
